// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3Cy4d","overflowing":"ReadFullNote_overflowing__3a7Ue"};